<template>
    <div class="container-fluid">
        <h4 class="bg-secondary text-white text-center p-2">Generación Ejercicio Direccionamiento IP con Clases</h4>
        <div class="container">
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('A')">Clase A</button>
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('B')">Clase B</button>
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('C')">Clase C</button>
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('D')">Clase D</button>
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('E')">Clase E</button>
        <button class="btn btn-secondary mx-2" 
            @click="setIPClass('R')">Al azar</button>
        </div>
        <class-addressing v-bind:ipaddress="ipgenerada" initial-value=""></class-addressing>
    </div>
</template>

<script>

import ClassAddressing from "./ClassAddressing";

var ip = require("ip");

    function generateClass(bc) {
        if (bc === 'R') {
            var lclass = Math.floor(Math.random() * 5);
            var letters = ['A', 'B', 'C', 'D', 'E'];
            bc = letters[lclass];
        }
        return bc;
    }

    function generateIP(ipclass) {
        var pb = 0;
        switch (ipclass) {
            case 'A':
                pb = Math.random() * 125 + 1;
                break;
            case 'B':
                pb = Math.random() * 64 + 128;
                break;
            case 'C':
                pb = Math.random() * 32 + 192;
                break;
            case 'D':
                pb = Math.random() * 16 + 224;
                break;
            case 'E':
                pb = Math.random() * 8 + 240;
                break;
        }
        var myip = new Buffer([pb, Math.random() * 256, Math.random() * 256, Math.random() * 255]);
        return ip.toString(myip);
    }

export default {
    data: function () {
        return {
            ipclass: '',
            ipclassnor: '',
            ipgenerada: '',
        }
    },
    watch: {
        ipclass(value) { this.ipclassnor = generateClass(value); this.ipgenerada = generateIP(this.ipclassnor); }
    },
    components: {ClassAddressing},
    methods: {
        setIPClass(ipc) {
            this.ipclass = ipc;
            this.ipclassnor = generateClass(ipc);
            this.ipgenerada = generateIP(this.ipclassnor);
        }
    }
}
</script>